import { Box } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";

const CHIP_WIDTHS = ["100px", "60px", "130px", "70px", "90px"];

export const FilterChipsSkeleton = (): JSX.Element => (
  <Box
    display="flex"
    flexDirection="row"
    gap="small"
    data-id="filter-chips-skeleton"
    style={{ flexWrap: "wrap" }}
  >
    {CHIP_WIDTHS.map((width, i) => (
      <Box key={i} data-id={`filter-chip-skeleton-${i}`} borderRadius="xxsmall">
        <Skeleton
          variant="rectangular"
          width={width}
          height={32}
          backgroundColor="light"
        />
      </Box>
    ))}
  </Box>
);
